import { assertNotEmpty, type Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import cx from 'classnames'

import { useTemplateContext } from '../../context/templateContext'
import type { FieldOrigin } from '../../uiModels/types'
import { FPlusDiffLayoutControl } from '../fplusDiff/FPlusDiffLayoutControl'
import { DiffHeader } from './DiffHeader'
import { DiffTitle } from './DiffTitle'
import { useCompareContext } from './valueSetupCompareContext'

type Props = {
  current: Optional<FieldOrigin>
  compare: Optional<FieldOrigin>
  fieldName?: string
}

export const TemplateFieldDiffHeader = ({
  current,
  compare,
  fieldName,
}: Props) => {
  const { templateVersion, isDiffingAgainstShadowedVersion } =
    useTemplateContext()
  const translate = useTranslate()
  const { compareType } = useCompareContext()

  assertNotEmpty(templateVersion)

  const previousTemplateTitle = isDiffingAgainstShadowedVersion
    ? translate('diffPopover.title.shadowed')
    : translate('diffPopover.title.previous')

  return (
    <>
      <div
        className={cx('flex w-full flex-row items-baseline justify-between', {
          'text-warning-500 dark:text-warning-300':
            isDiffingAgainstShadowedVersion,
        })}
      >
        <DiffTitle>
          {compareType === 'previous'
            ? previousTemplateTitle
            : translate('diffPopover.title.inherited')}
          {!!fieldName && (
            <span className="normal-case">{` (${fieldName})`}</span>
          )}
        </DiffTitle>
        <DiffHeader origin={compare} variant="compare" />
      </div>
      <div className="flex w-full flex-row items-baseline justify-between">
        <DiffTitle>
          {translate('diffPopover.title.current')}
          {!!fieldName && (
            <span className="normal-case">{` (${fieldName})`}</span>
          )}
        </DiffTitle>

        <DiffHeader origin={current} variant="current" />
      </div>
      <FPlusDiffLayoutControl />
    </>
  )
}
